import React from "react";
import classNames from "classnames";
import { Copy } from "react-feather";

import { TableButton } from "components/TableButton";

import "./cut.scss";
import { toast } from "react-toastify";


export const Cut = ({ children, text = null, width = false }) => {

  const copy = async (text) => {
    try {
      await navigator.clipboard.writeText(text.replace(/<[^>]*>/g, ''));
      toast.success(`${text} скопирован в буфер обмена`);
    } catch (err) {
      toast.error('Ошибка при копировании текста: ' + err);
    }
  };

  return (
    <div className={classNames("cut", { "width": width })}>
      <span>{children}</span>
      <div className="cut__hover">
        <div className="cut__text">
          {children}
        </div>
      </div>
    </div>
  );
};
